import { DEFAULT_FUTURE_CANCEL_DATE_MAX_NUMBER_OF_DAYS } from './cancelForm.constants';

export const getMaxNumberOfDaysAllowedForProduct = (): number =>
  DEFAULT_FUTURE_CANCEL_DATE_MAX_NUMBER_OF_DAYS;
